import {
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react'
import React, { useState } from 'react'
import { MdSearch, MdSort } from 'react-icons/md'
import CustomMenu from '../../components/menu'
import { useLanguageContext } from '../../context/locale.context'
import { sectionDetailedTrack } from '../repository/repo.utils'
import { GA_CATEGORY_VIDM } from './../repository/repo.utils'

export default function VidmHeader({
  filterOptions,
  selected,
  onChange,
  onSearch,
}) {
  const [searchQuery, setSearchQuery] = useState('')
  const {
    state: { locale },
  } = useLanguageContext()
  return (
    <>
      <Flex justifyContent="flex-end" alingItems="center" w="full">
        <InputGroup flex={1} boxShadow="md" maxW="300px" mx={2}>
          <Input
            bg="white"
            placeholder={locale['Smart search']}
            borderRadius="md"
            value={searchQuery}
            variant="filled"
            onChange={e => setSearchQuery(e.target.value)}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                onSearch(event.target.value)
              }
            }}
            _focus={{
              border: 'none',
              background: 'white',
            }}
          />
          <InputRightElement
            onClick={() => {
              sectionDetailedTrack({
                category: GA_CATEGORY_VIDM,
                action: 'Vidm Header',
                label: 'Search',
              })
              onSearch(searchQuery)
            }}
            children={<Icon as={MdSearch} color="green.500" w={6} h={6} />}
          />
        </InputGroup>
        <CustomMenu
          optionList={filterOptions}
          selected={selected}
          isFilter={true}
          onSelect={item => {
            onChange(item)
          }}
          icon={MdSort}
        />
      </Flex>
    </>
  )
}
